import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";

function ensureHeadAsset(rel: string, href: string, attributes: Record<string, string> = {}) {
  let link = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!link) {
    link = document.createElement("link");
    link.rel = rel;
    document.head.append(link);
  }
  link.href = href;
  Object.entries(attributes).forEach(([key, value]) => link?.setAttribute(key, value));
}

ensureHeadAsset("icon", "/favicon.svg", { type: "image/svg+xml" });
ensureHeadAsset("manifest", "/manifest.webmanifest");
ensureHeadAsset("apple-touch-icon", "/icon-192.svg");
document.documentElement.lang = "de";
document.documentElement.dir = "ltr";
const description = document.querySelector<HTMLMetaElement>('meta[name="description"]');
if (description) {
  description.content = "F‑Bucks – private Spielplattform mit rein virtueller Währung.";
}

const root = document.getElementById("root");
if (!root) throw new Error("Root-Element fehlt.");
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
